function formatTime(hour24, minute) {
  const period = hour24 < 12 ? 'AM' : 'PM';
  const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;

  return `${hour12}:${minute.toString().padStart(2, '0')} ${period}`;
}

export default function WeekGridHour({ hour, gridStep }) {
  const minute = gridStep?.minute ?? 0;

  const label = formatTime(hour, minute);

  return <span className="sx__week-grid__hour-text">{label}</span>;
}
